import {Query, gql} from 'apollo-angular';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class GetUnitPreferencesQuery extends Query<any> {
  document = gql`
      query getUnitPreferences {
          user {
              _id
              preferences {
								unitFormatPreferences {
                      active {
                          label
                          value
                      }
                      options {
                          label
                          value
                      }
                  }
              }
          }
      }
  `;
}
